import _                                                          from 'underscore';
import React                                                      from 'react';
import { Align }                                                  from "@src/types";
import { StaticProjectActivityBulkUpdateShellFormContainerProps } from "@src/views/pages/projects/activities/bulk/StaticProjectActivityBulkUpdateShell";
import { QueryDialogProps, QueryOpDialog }                        from "@src/views/components/from-query/QueryOpDialog";
import { BasicDialogContainer }                                   from "@src/views/components/modals/BasicDialogContainer";


interface StaticStaticProjectActivityBulkUpdateDialogFormContainerProps extends QueryDialogProps, StaticProjectActivityBulkUpdateShellFormContainerProps {
    title?: string,
}

const StaticStaticProjectActivityBulkUpdateDialogFormContainerDefaultProps = {
    title: 'Bulk Update',
} satisfies Partial<StaticStaticProjectActivityBulkUpdateDialogFormContainerProps>

function StaticStaticProjectActivityBulkUpdateDialogFormContainer( { children, ...p }: StaticStaticProjectActivityBulkUpdateDialogFormContainerProps ){

    const props = { ...StaticStaticProjectActivityBulkUpdateDialogFormContainerDefaultProps, ...p } as StaticStaticProjectActivityBulkUpdateDialogFormContainerProps;

    return (
        <QueryOpDialog
            showOperationInTransitMessage={ false }
            showOperationInTransitOnSubmit={ true }
            operationDisabled={ props.operationDisabled }
            closeIsDisabled={ props.isProcessing || props.isLoading }
            mutation={ props.mutation }
            graphArgs={ props.getGraphArgs }
            confirmationHandler={ null }
            onSubmit={ props.onSubmit }
            onComplete={ props.onComplete }
            onError={ props.onError }
            onClose={ props.onClose }
            cancelLabel={ 'Close' }
            submitLabel={ 'Update Activity Set' }
            successToastLabel={ null }
            overflow={ true }
            className={ 'no-padding' }
            alignControls={ Align.CENTER }
            { ..._.omit( props, _.keys( StaticStaticProjectActivityBulkUpdateDialogFormContainerDefaultProps ) ) }>

            <BasicDialogContainer title={ props.title } contentPadding={ null } overflow={ true }>

                { children }

            </BasicDialogContainer>

        </QueryOpDialog>
    );
}

export {
    StaticStaticProjectActivityBulkUpdateDialogFormContainer,
    StaticStaticProjectActivityBulkUpdateDialogFormContainerDefaultProps,
    type StaticStaticProjectActivityBulkUpdateDialogFormContainerProps,
};
